import Link from 'next/link'
import SolidButton from '@/components/Common/Button/SolidButton'
import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import { useTranslation } from 'react-i18next'

const StartLearning = () => {
  const { code } = useCompanyContext()
  const { t } = useTranslation('common')

  return (
    <>
      <div className="flex items-center justify-center">
        <p className="text-sm font-semibold text-normal lg:text-lg">
          {t('cta.startLearning.message')}
        </p>
      </div>
      <div className="w-full lg:max-w-[160px]">
        <Link href={`/my/programs/${code}/board`}>
          <SolidButton className="!h-10 !w-full lg:!h-11">
            {t('cta.startLearning.button')}
          </SolidButton>
        </Link>
      </div>
    </>
  )
}

export default StartLearning
